import { setReferralCodeToLS, getReferralCodeFromLS, clearReferralCodeFromLS } from './localStorage';

/**
 * Captures referral code from URL parameter 'ref' and stores it in localStorage
 * @param searchParams - URLSearchParams from current location
 * @returns The captured referral code or null if not found
 */
export const captureReferralCodeFromURL = (searchParams: URLSearchParams): string | null => {
  const referralCode = searchParams.get('ref');

  if (referralCode && referralCode.trim()) {
    // Validate referral code format (alphanumeric, uppercase)
    const isValidFormat = /^[A-Z0-9]+$/.test(referralCode.trim());

    if (isValidFormat) {
      setReferralCodeToLS(referralCode.trim());
      return referralCode.trim();
    }
  }

  return null;
};

/**
 * Gets the stored referral code from localStorage
 * @returns The stored referral code or null if not found
 */
export const getStoredReferralCode = (): string | null => {
  const code = getReferralCodeFromLS();
  return code || null;
};

/**
 * Clears the stored referral code from localStorage
 * This should be called after successful registration/login with referral
 */
export const clearStoredReferralCode = (): void => {
  clearReferralCodeFromLS();
};

/**
 * Checks if there's a valid referral code in localStorage
 * @returns boolean indicating if a valid referral code exists
 */
export const hasValidReferralCode = (): boolean => {
  const code = getReferralCodeFromLS();
  return !!(code && /^[A-Z0-9]+$/.test(code));
};
